module.exports = require("@swa-ui/vacations/src/VacationsBookingForm/PromoCode/PromoCode.module.scss");